import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import { SAVE_ALLOWED_DOMAIN_MUTATION } from '../queries/saveAllowedDomainsMutation';
import {
  SaveAllowedDomainMutation,
  SaveAllowedDomainMutationVariables,
} from '../queries/types/SaveAllowedDomainMutation';

type IOptions = MutationHookOptions<SaveAllowedDomainMutation, SaveAllowedDomainMutationVariables>;

export const useSaveAllowedDomain = (options: IOptions = {}) =>
  useMutation<SaveAllowedDomainMutation, SaveAllowedDomainMutationVariables>(SAVE_ALLOWED_DOMAIN_MUTATION, options);
